import { setDateMaterialFormat } from './utils/utils'
import api from './commomFun/api'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default new Vuex.Store({
	state: {
		formItem: {
			companyId: '-',
			companyName: '无',
			companyBrandId: '',
			companyBrand: '无',
			planName: '无',
			adSystemId: '',
			adSystemName: '不限',
			priceStrategy: '1',
			beginTime: '',
			endTime: '',
			target: '-',
		},
		target: [],
		areaPushNum: [],
		inputNetwork: [], //导入表格
		importWorke: {}, //导入点位或则网点的时候需要一个默认参数

		//多画面物料数据
		framesList: [
			{
				framesName: '画面一',
				lastFramesName: '画面一', //编辑时候 保存则赋值，取消则保持lastFramesName
				checked: true, //画面是否被选中
				isNew: true, //是否是新增画面
				tagColor: 'rgba(24, 144, 255, 1)', //画面颜色
				playDates: [], //这个画面要播放的日期
				adMaterialDetail: {}, //物料信息
				isEdit: false,
			},
		],
		//当前画面物料信息
		currentAdMaterialDetail: {},
		framesTagColor: 'rgba(24, 144, 255, 1)', //当前选择画面所代表的颜色
		totalPlayDateNum: 0, //能够选择的日期总数
		playDateNum: 0, //已经选择的日期数量
		selectDateList: [], //被选择的日期 [{date:'2012-06-07',tagColor:'rgba(24, 144, 255, 1)'}]
		isUpload: false,
	},
	actions: {
		changeFormItem(ctx, formItem) {
			ctx.commit('changeFormItem', formItem)
		},
		changeAreaPushNum(ctx, areaPushNum) {
			ctx.commit('changeAreaPushNum', areaPushNum)
		},

		//多画面请求物料信息
		getMaterialList({ commit, stat }, planId) {
			return api.getApi('/material/list', { planId }).then((res) => {
				let data = setDateMaterialFormat(res.data.data[0])
				commit('setFramesData', data)
				return res.data
			})
		},
	},
	mutations: {
		changeFormItem(state, formItem) {
			state.formItem = formItem
		},
		changeAreaPushNum(state, areaPushNum) {
			state.areaPushNum = areaPushNum
		},
		inputNetworkFun(state, arr) {
			state.inputNetwork = arr
		},
		//储存导入选点参数
		importWorkeFun(state, obj) {
			state.importWorke = obj
		},

		//多画面相关
		//新增多画面
		addFrames(state, newFrames) {
			state.framesList.push(newFrames)
		},
		//选中画面
		checkedFrames(state, item) {
			//所有checked都为false
			//点击的元素checked都为true
			state.framesList.forEach((i) => {
				i.checked = false
			})
			item.checked = true
			state.framesTagColor = item.tagColor
			//选中画面相应的物料也要发生改变
			state.currentAdMaterialDetail = item.adMaterialDetail
		},
		//删除画面,并且右边的颜色全部取消 //根据数据改变颜色
		delectFrames(state, framesindex) {
			const framesList = [...state.framesList]
			state.framesList = framesList.filter((item, index) => {
				//index不等的数据拿出来组成新数组
				if (index !== framesindex) {
					return true
				} else {
					//删除画面的同时将画面索选择的日期也一起删除
					state.currentAdMaterialDetail = {}
					if (item.playDates.length) {
						item.playDates.forEach((i) => {
							state.selectDateList.forEach((item, index, arr) => {
								if (item.date == i) {
									arr.splice(index, 1)
								}
							})
						})
					}
				}
			})
			//如果该画面没有被选择的，则默认选择第一个画面
			let isChecked = state.framesList.some((item) => {
				return item.checked
			})
			if (!isChecked) {
				state.framesList[0].checked = true
				state.framesTagColor = state.framesList[0].tagColor
				state.currentAdMaterialDetail =
					state.framesList[0].adMaterialDetail
			} else {
				state.currentAdMaterialDetail = state.framesList.filter(
					(item) => {
						return item.checked
					}
				)[0].adMaterialDetail
			}
		},
		//向画面中添加日期
		pushPlayDates(state, dateItem) {
			state.framesList
				.filter((item) => item.checked)[0]
				.playDates.push(dateItem.date)
			//向已选点位合集里新增点位
			state.selectDateList.push({
				date: dateItem.date,
				bgc: dateItem.bgc,
			})
		},
		//向画面中删除日期
		delectPlayDates(state, dateItem) {
			state.framesList
				.filter((item) => item.checked)[0]
				.playDates.forEach((item, index, arr) => {
					if (item == dateItem.date) {
						arr.splice(index, 1)
					}
				})
			// state.playDateNum -= 1
			state.selectDateList.forEach((item, index, arr) => {
				if (item.date == dateItem.date) {
					arr.splice(index, 1)
				}
			})
		},
		//统计这个月可选的日期天数
		addPlayDateNum(state) {
			state.totalPlayDateNum += 1
		},
		resetPlayDateNum(state) {
			state.totalPlayDateNum = 0
		},
		//修改当前选择画面的物料信息
		changeFramesMaterial(state, obj) {
			state.currentAdMaterialDetail = { ...obj }
			state.framesList.filter(
				(item) => item.checked
			)[0].adMaterialDetail = { ...obj }
		},
		//统计已选点位数量
		computePlayDateNum(state) {
			state.playDateNum = state.selectDateList.length
		},

		//改变画面属性
		changeAttribute(state, { item, att, value }) {
			item[att] = value
		},
		//改变上传状态
		changeUploadStatu(state, value) {
			state.isUpload = value
		},
		//重置多画面相关数据
		resetData(state) {
			//清空
			state.framesList = [
				{
					framesName: '画面一',
					lastFramesName: '画面一',
					checked: true,
					isNew: true,
					tagColor: 'rgba(24, 144, 255, 1)',
					playDates: [],
					adMaterialDetail: {},
					isEdit: false,
				},
			]
			state.currentAdMaterialDetail = state.framesList[0].adMaterialDetail
			state.framesTagColor = 'rgba(24, 144, 255, 1)'
			state.totalPlayDateNum = 0
			state.playDateNum = 0
			state.selectDateList = []
			state.isUpload = false
		},
		//设置多画面相关数据
		setFramesData(state, data) {
			state.framesList = []
			state.selectDateList = []
			data.adMaterialDetail.forEach((item) => {
				state.framesList.push({
					framesName: item.materialName,
					lastFramesName: item.materialName, //编辑时候 保存则赋值，取消则保持lastFramesName
					checked: false, //画面是否被选中
					isPlay: data.planStatus == 2 ? true : false,
					// isNew: true, //是否是新增画面
					tagColor: item.tagColor, //画面颜色
					playDates: item.playDates, //这个画面要播放的日期
					adMaterialDetail: {
						isPlay: data.planStatus == 2 ? true : false,
						fullImageUrl: item.fileUrl,
						fullImageName: item.fileName,
						planId: data.planId ? data.planId : '',
						fileType: item.fileType,
						fullImageFileId: item.fileId,
						fullImageFileMd5: item.fileMd5,
						fullImageFileUrl: item.fileUrl,
						adSpace: 3, // 1为上半屏，2为下半屏，3为下半屏+上半屏（也就是全屏）
						fileId: item.fileId,
						fileCryptUrl: item.fileCryptUrl,
						videoSnapshotUrl: item.videoSnapshotUrl,
						// 画面审核状态：-1审核拒绝 0待审核 1审核通过
						auditStatus: item.auditStatus,
						materialInfo: item.materialInfo,
						materialId: item.materialId ? item.materialId : '', //上传的时候没有，请求得到物料详情的时候存在
						id: item.id ? item.id : '', // 订单详情查询的时候会返回id
						isNew: item.isNew ? true : false,
					}, //物料信息
					isEdit: false,
				})
				item.playDates.forEach((i) => {
					//被选择的日期 [{date:'2012-06-07',tagColor:'rgba(24, 144, 255, 1)'}]
					state.selectDateList.push({
						date: i,
						bgc: item.tagColor,
					})
				})
			})
			//默认选中第一项
			if (state.framesList[0]) {
				state.framesList[0].checked = true
				state.currentAdMaterialDetail =
					state.framesList[0].adMaterialDetail
				state.framesTagColor = state.framesList[0].tagColor //当前选择画面所代表的颜色
			} else {
				state.currentAdMaterialDetail = {}
				state.framesTagColor = ''
			}
			state.totalPlayDateNum = 0 //能够选择的日期总数
			state.playDateNum = 0 //已经选择的日期数量
			state.isUpload = false
		},
		//将本地缓存设置到vuex
		setStorageFramesData(state, date) {
			let {
				framesList,
				currentAdMaterialDetail,
				framesTagColor,
				totalPlayDateNum,
				selectDateList,
				playDateNum,
				isUpload,
			} = date
			state.framesList = framesList
			state.currentAdMaterialDetail = currentAdMaterialDetail
			state.framesTagColor = framesTagColor
			state.totalPlayDateNum = totalPlayDateNum //为了不使totalPlayDateNum叠加增长
			state.selectDateList = selectDateList
			state.playDateNum = playDateNum
			state.isUpload = false
		},

		//清空state中物料信息
		clearAdMaterialDetail(state, type) {
			state.framesList.forEach((item) => {
				//如果素材是视频则清除
				item.videoSnapshotUrl && (item.adMaterialDetail = {})
				//如果修改广告位，所有物料都清除
				type == 'positionId' && (item.adMaterialDetail = {})
			})
			state.currentAdMaterialDetail = {}
			try {
				let framesData = JSON.parse(
					window.sessionStorage.getItem('framesData')
				)
				framesData.framesList.forEach((item) => {
					item.adMaterialDetail = {}
				})
				framesData.currentAdMaterialDetail = {}
				window.sessionStorage.setItem(
					'framesData',
					JSON.stringify(framesData)
				)
			} catch (error) {}
		},
		//清空state中选择日期相关信息
		clearDate(state) {
			state.framesList.forEach((item) => {
				item.playDates = []
			})

			state.selectDateList = []
			state.totalPlayDateNum = 0 //能够选择的日期总数
			state.playDateNum = 0

			//处理本地缓存数据
			try {
				let framesData = JSON.parse(
					window.sessionStorage.getItem('framesData')
				)
				framesData.framesList.forEach((item) => {
					item.playDates = []
				})
				framesData.selectDateList = []
				framesData.totalPlayDateNum = 0 //能够选择的日期总数
				framesData.playDateNum = 0
				window.sessionStorage.setItem(
					'framesData',
					JSON.stringify(framesData)
				)
			} catch (error) {}
		},
	},
})
